import * as mUtils from "@/config/mUtils.js";  
export default {
	methods:{
		async myHttp(callback,params={}){
			let res = await callback(params);
			if(res.data.code == -1){
				return this.resSuccess(res.data);
			}else if(res.data.code == 5 || res.data.code == 70){					// 调研问卷 先前已经提交过了 返回上一页面
				alert(res.data.message);
				//this.$router.back(-1);
				return "5or70";
			}else if(res.data.code == 94 || res.data.code == 95){
				await mUtils.checkOpenid(this.$route.path);
			}else{
				alert('请求异常')
				return this.getDataType(res.data.data||""); 
			}
		},
		resSuccess(res){
			this.loading = true;
			return res.data;
		},
		getDataType(o){
			// var o = {};
			if(mUtils.getDataType(o)){
				this.loading = true;
				this.showp = true;
				return true;
			}
			return false;
		}, 
	}
}


// WEBPACK FOOTER //
// ./src/myMixin/myHttp/myHttp.js